import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=4003f136&scoped=true&"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetail.vue?vue&type=style&index=0&id=4003f136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003f136",
  null
  
)

export default component.exports